import React from "react";
import {
  SeoBreadcrumbCurrent,
  SeoBreadcrumbItem,
  SeoBreadcrumbList,
  SeoBreadcrumbNavigation,
} from "../styledComponents/StyledTables";

const SeoBreadcrumbs = ({
  items = [],
  ariaLabel = "Breadcrumb",
  game = false,
}) => {
  if (!items || items.length < 2) {
    return null;
  }

  return (
    <SeoBreadcrumbNavigation aria-label={ariaLabel} Ingame={game}>
      <SeoBreadcrumbList Ingame={game}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <SeoBreadcrumbItem key={`${item.url || item.name}-${index}`}>
              {isLast ? (
                <SeoBreadcrumbCurrent aria-current="page">
                  {item.name}
                </SeoBreadcrumbCurrent>
              ) : (
                <a
                  href={item.url}
                  onMouseDown={(event) => event.preventDefault()}
                >
                  {item.name}
                </a>
              )}
            </SeoBreadcrumbItem>
          );
        })}
      </SeoBreadcrumbList>
    </SeoBreadcrumbNavigation>
  );
};

export default SeoBreadcrumbs;
